module.exports = __webpack_public_path__ + "static/media/15b-05_Serie-blanca-5-2015-200x300cm-oleo-sobre-papel.b1d9a06c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15b/15b-05_Serie-blanca-5-2015-200x300cm-oleo-sobre-papel.jpg
// module id = 161
// module chunks = 0